var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca ng-click=\"editContact()\"\u003E{{ 'Edit' | translate }}\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;